// extracted by mini-css-extract-plugin
export default {"row":"Dc_yNDDKbrWEwbF2I8_8"};